import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { headerDataAutomation } from "app/pages/activation/components/Header/dataAutomationKeys";
import { loaderSizes } from "app/pages/activation/components/Header/Loader/config";

import * as SC from "./styles";

export const Loader = () => {
    return (
        <SC.Container data-automation={headerDataAutomation.loader}>
            <SC.Section>
                <PixelPlaceholderLoader
                    width={loaderSizes.breadcrumbs.width}
                    height={loaderSizes.breadcrumbs.height}
                />
            </SC.Section>

            <SC.Section>
                <SC.SubSection>
                    <PixelPlaceholderLoader
                        className="icon"
                        width={loaderSizes.icon.width}
                        height={loaderSizes.icon.height}
                    />
                    <PixelPlaceholderLoader
                        width={loaderSizes.name.width}
                        height={loaderSizes.name.height}
                    />
                    <PixelPlaceholderLoader
                        className="rounded"
                        width={loaderSizes.icon.width}
                        height={loaderSizes.icon.height}
                    />
                    <PixelPlaceholderLoader
                        className="rounded"
                        width={loaderSizes.icon.width}
                        height={loaderSizes.icon.height}
                    />
                </SC.SubSection>

                <PixelPlaceholderLoader
                    className="roundedButton"
                    width={loaderSizes.button.width}
                    height={loaderSizes.button.height}
                />
            </SC.Section>

            <SC.Section>
                <SC.SubSection>
                    <PixelPlaceholderLoader
                        width={loaderSizes.text.width}
                        height={loaderSizes.text.height}
                    />
                    <PixelPlaceholderLoader
                        width={loaderSizes.link.width}
                        height={loaderSizes.link.height}
                    />
                    <PixelPlaceholderLoader
                        width={loaderSizes.link.width}
                        height={loaderSizes.link.height}
                    />
                    <PixelPlaceholderLoader
                        width={loaderSizes.link.width}
                        height={loaderSizes.link.height}
                    />
                </SC.SubSection>

                <SC.SubSection>
                    <PixelPlaceholderLoader
                        width={loaderSizes.text.width}
                        height={loaderSizes.text.height}
                    />
                    <PixelPlaceholderLoader
                        width={loaderSizes.granularity.width}
                        height={loaderSizes.granularity.height}
                    />
                </SC.SubSection>
            </SC.Section>
        </SC.Container>
    );
};
